import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Routes } from '../routes';

const TABS = [
    { label: 'Initiate Pricing',     path: Routes.TradeInPricing.path },
    { label: 'Promotional Campaign', path: Routes.TradeInPricingPromotional.path },
    { label: 'Pricing History',      path: Routes.TradeInPricingHistory.path },
];

export default function TradeInPricingTabs() {
    const history  = useHistory();
    const location = useLocation();

    return (
        <>
            <div className="breadcrumb">
                <span className="breadcrumb-item">Pricing</span>
                <span className="breadcrumb-separator">  </span>
                <span className="breadcrumb-item">&nbsp;/ Trade-In Pricing</span>
            </div>

            <div className="tabs">
                {TABS.map((tab) => (
                    <button
                        key={tab.path}
                        className={`tab ${location.pathname === tab.path ? 'active' : ''}`}
                        onClick={() => history.push(tab.path)}
                        style={{
                            borderRadius: '8px',
                            display: 'flex',
                            minWidth: '88px',
                            padding: '10px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                            color: location.pathname === tab.path ? '#212529' : '#6C757D',
                            fontFamily: 'Montserrat',
                            fontSize: '12px',
                            fontWeight: 600,
                        }}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
        </>
    );
}
